import React, { useEffect, useState } from 'react';
import styles from '../../../styles/common/common-styles.module.scss';
import PrevQuestionLink from '../prevQuestionLink/prevQuestionLink';
import Button from '../button/Button';

const Question3 = props => {
  return (
    <div className={`row ${styles.questionWrap}`}>
      <div className={`col`}>
        <PrevQuestionLink
          setCurrentQuestion={props.setCurrentQuestion}
          prevQuestionIndex={2}
          errorState={props.errorState}
        ></PrevQuestionLink>
        {!props.errorState ? (
          <h3 className={`${styles.pageTitle}`}>Name on death certifcate</h3>
        ) : null}
        <div className={`col-lg-7 col-md-10 row ${styles.mobileRow}`}>
          <label htmlFor={`deceasedGivenName`} className={`${styles.nswFormLabel}`}>
            Given name
          </label>
          <input
            id={'deceasedGivenName'}
            name={'deceasedGivenName'}
            className={`nsw-form-input ${styles.nswFormInput}`}
            value={props.firstname && props.firstname.length > 0 ? props.firstname : undefined}
            onInput={event => {
              props.setFirstname(event.target.value);
            }}
          />
        </div>
        <div className={`col-lg-7 col-md-10 row ${styles.mobileRow}`}>
          <label htmlFor={`deceasedMiddleName`} className={`${styles.nswFormLabel}`}>
            Middle name (optional)
          </label>
          <input
            id={'deceasedMiddleName'}
            name={'deceasedMiddleName'}
            className={`nsw-form-input ${styles.nswFormInput}`}
            value={props.middlename && props.middlename.length > 0 ? props.middlename : undefined}
            onChange={event => {
              props.setMiddlename(event.target.value);
            }}
          />
        </div>
        <div className={`col-lg-7 col-md-10 row ${styles.mobileRow}`}>
          <label htmlFor={`deceasedLastName`} className={`${styles.nswFormLabel}`}>
            Last name
          </label>
          <input
            id={'deceasedLastName'}
            name={'deceasedLastName'}
            className={`nsw-form-input ${styles.nswFormInput}`}
            value={props.lastname && props.lastname.length > 0 ? props.lastname : undefined}
            onChange={event => {
              props.setLastname(event.target.value);
            }}
          />
        </div>
        {!props.errorState ? (
          <div className={styles.btnWrap}>
            <Button
              disabled={!props.firstname || !props.lastname}
              onClick={() => {
                props.setCurrentQuestion(4);
              }}
            >
              Next
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Question3;
